import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

export function useMePointsBalanceVisible(): boolean {
  const flagsQuery = usePublicFeatureFlags()
  const reservation = flagsQuery.data?.find((row) => row.module_name === 'reservation')
  const raw = reservation?.metadata?.points_balance_visible

  if (typeof raw === 'boolean') {
    return raw
  }

  return true
}
